import CustomTable from "@/components/customTable/CustomTable";
import { Box, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  getDrugsInArea,
  putAddDrugInArea,
  putAddEquipmentInArea,
} from "../../../api/area";
import {
  addAllEquipmentsToArea,
  getEquipmentCount,
} from "../../../api/jahadgar";
import FlagIcon from "../../../assets/SVG/flagIcon";
import CountDrugPop from "../countDrugPop";

export default function GroupTableOnline({
  rowData,
  setRowData,
  dataDrugSelect,
  equipment,
  notGroup,
}) {
  const [open, setOpen] = useState();
  const [dataCountDrug, setDataCountDrug] = useState();
  const [areaId, setAreaId] = useState();

  const colDefs = useMemo(
    () => [
      {
        headerName: "نام گروه",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`group_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : "unset"}
            >
              {x.data.groupsWithAccess?.length > 0 &&
                x.data.groupsWithAccess[0].group.name}
            </Box>
          );
        },
      },
      {
        headerName: "منطقه",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`area_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : "unset"}
            >
              <Typography fontFamily="Vazirmatn">{x.data?.name}</Typography>
            </Box>
          );
        },
      },
      {
        headerName: "مسئول منطقه",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`area_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : "unset"}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.areas?.length > 0 && x.data?.areas[0]?.owner?.name}
              </Typography>
            </Box>
          );
        },
      },
      {
        headerName: "تعداد",
        field: "neededCount",
        width: 110,
        editable: true,
        onCellValueChanged: (params) => {
          setRowData(
            rowData.map((item) => {
              if (item.id === params.data.id) {
                return {
                  ...item,
                  neededCount: Number(params.newValue),
                };
              }
              return item;
            }),
          );
        },
      },
      {
        headerName: "عملیات",
        width: 250,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`op_${x.id}`}
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <button
                style={{
                  display: "flex",
                  border: "none",
                  background: "#00A3FF",
                  borderRadius: "9px",
                  padding: "5px",
                  // fontFamily: "Shabnam !important ",
                }}
                onClick={() => {
                  const updatedArray = dataDrugSelect.map((item) => {
                    return {
                      ...item,
                      totalCount: Number(x.data.neededCount),
                    };
                  });
                  if (equipment) {
                    if (notGroup) {
                      addAllEquipmentsToArea(x.data?.id, updatedArray)
                        .then(() => toast.success("تجهیزات انتقال پیدا کرد"))
                        .catch(() => {});
                    } else {
                      putAddEquipmentInArea(x.data?.areas[0]?.id, updatedArray)
                        .then(() => toast.success("تجهیزات انتقال پیدا کرد"))
                        .catch(() => {});
                    }
                  } else {
                    putAddDrugInArea(
                      notGroup ? x.data?.id : x.data?.areas[0]?.id,
                      updatedArray,
                    )
                      .then(() => toast.success("دارو انتقال پیدا کرد"))
                      .catch((z) => {
                        toast.error(z?.data?.msg);
                      });
                  }
                }}
              >
                <FlagIcon color="white" />
                <Typography
                  color="white"
                  fontSize="14px"
                  fontFamily="Vazirmatn"
                >
                  افزودن به اردو
                </Typography>
              </button>
              <button
                style={{
                  display: "flex",
                  border: "none",
                  background: "#00A3FF",
                  borderRadius: "9px",
                  padding: "5px",
                  // fontFamily: "Shabnam !important ",
                }}
                onClick={() => {
                  if (equipment) {
                    if (notGroup) {
                      getEquipmentCount(x.data?.id)
                        .then((z) => {
                          setDataCountDrug(z);
                          setAreaId(x.data?.id);
                          setOpen(true);
                        })
                        .catch(() => {});
                    } else {
                      getEquipmentCount(x.data?.areas[0]?.id)
                        .then((z) => {
                          setDataCountDrug(z);
                          setAreaId(x.data?.areas[0]?.id);
                          setOpen(true);
                        })
                        .catch(() => {});
                    }
                  } else {
                    if (notGroup) {
                      getDrugsInArea(x.data?.id, 0, 10)
                        .then((z) => {
                          setDataCountDrug(z);
                          setAreaId(x.data?.id);
                          setOpen(true);
                        })
                        .catch(() => {});
                    } else {
                      getDrugsInArea(x.data?.areas[0]?.id, 0, 10)
                        .then((z) => {
                          setDataCountDrug(z);
                          setAreaId(x.data?.areas[0]?.id);
                          setOpen(true);
                        })
                        .catch(() => {});
                    }
                  }
                }}
              >
                <Typography
                  color="white"
                  fontSize="14px"
                  fontFamily="Vazirmatn"
                >
                  مشاهده تعداد
                </Typography>
              </button>
            </Box>
          );
        },
      },
    ],
    [rowData],
  );

  return (
    <>
      <CountDrugPop
        equipment={equipment}
        areaId={areaId}
        data={dataCountDrug}
        open={open}
        setOpen={setOpen}
      />
      <CustomTable needPagination={false} rowData={rowData} columns={colDefs} />
    </>
  );
}
